export function handleUnAuthError(status: number) {
  if (status === 401) {
    localStorage.removeItem('token')
  }
}
